var _style, _circle, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 363.43 360",
    style: {
      enableBackground: "new 0 0 363.43 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6F52EA;}\r\n\t.st1{fill:none;stroke:#6F52EA;stroke-width:15.9836;stroke-miterlimit:0.1;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 181.71,
    cy: 100.49,
    r: 17.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 181.71,
    cy: 180,
    r: 156.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.93,283.2h-4.43c-8.42,0-15.24-6.82-15.24-15.24V144.07c0-8.42,6.82-15.24,15.24-15.24h4.43 c8.42,0,15.24,6.82,15.24,15.24v124.61C199.17,277.1,192.35,283.92,183.93,283.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.7bd93b71840ceba7e76e14c7c9cf21a4.svg";
export { ForwardRef as ReactComponent };